/*
Imports the borrower-lead-generation-tool in a wrapper that allows custom
styles. We pass all of the props previously sent to the generate lead api.
Previously, a description prop was passed, but this is not a writeable key
within the api. Because of this, description was updated to leadSourceKeyword
*/

import "./styles.css";
import React, { useCallback, useState } from "react";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";

const ContactUs = (props) => {
  // stores current formRef
  const [node, setNode] = useState(null);
  // tracks changes to formRef and stores current with setNode
  const formRef = useCallback((node) => {
    setNode(node);
  }, []);

  return (
    <>
      <div id="ContactUs" className="FormBg">
        <div className={`formWrapper${node ? "" : " spacer"}`}>
          {node && (
            <div className="formHeader mb-2">
              <div className="modalformHeader FormHeaderForm mt-2 mb-3">
            {props.header ? props.header : "Contact Us"}
          </div>
              Fill out this form and we'll get back to you as soon as possible!
            </div>
          )}
          <div className="formBody">
            <BorrowerLeadGenerationTool
              ref={formRef}
              statesDomain={process.env.REACT_APP_STATE_DOMAIN}
              leadSource="INHNPORT-025"
              
            // leadSourceKeyword="MYTRUHOME" // per smarlyn, this is auto generated with leadSource
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
